import React, { createContext, useState } from 'react';
import { Modal } from '../components/containers/Modal';
import { GlobalError } from 'components/containers/GlobalError';
import { ApolloError } from '@apollo/client';

type ErrorBoundaryValueType = {
  error: ApolloError | Error | undefined;
  setError: React.Dispatch<React.SetStateAction<ApolloError | Error | undefined>>;
};

export const GlobalErrorModalContext = createContext<ErrorBoundaryValueType>({
  setError: () => {
    // ...
  },
  error: undefined
});

export const GlobalErrorModalProvider = ({ children }: { children: JSX.Element }) => {
  const [error, setError] = useState<ApolloError | Error | undefined>();

  return (
    <GlobalErrorModalContext.Provider value={{ error, setError }}>
      {children}
      {error && (
        <Modal
          size={'zoom'}
          showCloseIcon={false}
          closeOnClickOutside={false}
          closeOnEsc={false}
          footerContent={undefined}>
          <GlobalError error={error} />
        </Modal>
      )}
    </GlobalErrorModalContext.Provider>
  );
};
